<template>
    <div class="pagination_parent">
        <div class="pagegneshan-cl">{{$t('showing','Showing')}} <span>{{from}}</span> {{$t('to','to')}} <span>{{to}}</span> {{$t('of','of')}} <span>{{total}}</span> {{$t('results','results')}}</div>
        <ul class="pagination">
            <li class="page-item" @click="prevPage" v-if="pageNo>1">
            <button class="page-link" aria-label="Previous">
                <span aria-hidden="true">« {{$t('previous', 'Previous')}}</span>
            </button>
            </li>
            <li class="page-item"><button class="page-link active" href="#">{{ pageNo }}</button></li>
            <li class="page-item" @click="nextPage" v-if="pageNo<lastPage">
            <button class="page-link" aria-label="Next">
                <span aria-hidden="true">{{$t('next', 'Next')}} »</span>
            </button>
            </li>
        </ul>
    </div>
</template>
<script>
import VueAwesomePaginate from "vue-awesome-paginate";

export default {
    name: 'Pagination',
    methods: {
        prevPage() {
            this.$emit('prevPage');
        },
        nextPage() {
            this.$emit('nextPage');
        },
    },
    props: ['lastPage','pageNo','from','to','total'],
    emits:['prevPage','nextPage']
}
</script>
<style scoped>

.alignment{
    text-align: end;
    margin: 10px 40px;
}
.pagination-container {
    display: flex;
    column-gap: 10px;
}

.paginate-buttons {
    height: 40px;
    width: 40px;
    border-radius: 20px;
    cursor: pointer;
    background-color: rgb(242, 242, 242);
    border: 1px solid rgb(217, 217, 217);
    color: black;
}

.paginate-buttons:hover {
    background-color: #d8d8d8;
}

.active-page {
    background-color: #3498db;
    border: 1px solid #3498db;
    color: white;
}

.active-page:hover {
    background-color: #2988c8;
}
</style>    